<div class="input-group">
    <input [placeholder]="placeholder" class="form-control cursor-pointer" [matDatepicker]="picker"
        (dateChange)="onDateChange($event)" (click)="picker.open()" (blur)="onBlur()" [formControl]="ktDate">
    <mat-datepicker #picker></mat-datepicker>
    <div class="input-group-append">
        <div class="input-group-text">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        </div>
    </div>
</div>